import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatChipsModule } from '@angular/material/chips'

import { ChipsSelectorModule } from '../chips-selector'
import { CarrierLookupsSelectorInputComponent } from './carrier-lookups-selector.component'

@NgModule({
  imports: [
    CommonModule,
    ChipsSelectorModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatChipsModule,
    ReactiveFormsModule,
  ],
  declarations: [CarrierLookupsSelectorInputComponent],
  exports: [CarrierLookupsSelectorInputComponent],
})
export class CarrierLookupsSelectorModule {}
